import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { BookOpen, Code, Globe, Award } from 'lucide-react';

export default function AcademicsPage() {
  const programs = [
    { icon: Globe, title: 'English Speaking Program', desc: 'Enhancing communication skills' },
    { icon: Code, title: 'Computer & Coding Classes', desc: 'Digital literacy and programming' },
    { icon: BookOpen, title: 'Smart Classrooms', desc: 'Technology-enabled learning' },
    { icon: Award, title: 'Leadership Program', desc: 'Developing leadership qualities' }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Academics</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Comprehensive curriculum focused on academic excellence and skill development
          </p>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {programs.map((program, i) => (
              <GlassCard key={i} className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <program.icon className="w-8 h-8 text-blue-900" />
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-2">{program.title}</h3>
                <p className="text-slate-600">{program.desc}</p>
              </GlassCard>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
